define("shared/components/shared/wizards/device-setup", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Wizard @closable={{false}} @onFinish={{action @closeDeviceSetup}} as |wizard|>
    <wizard.slide as |slide|>
      <slide.body>
        <Shared::Wizards::DeviceSetup::StepOne
          @socialProfile={{@socialProfile}}
        />
      </slide.body>
      <slide.footer
        @onCancel={{action @cancelDeviceSetup}}
        @isDisabled={{this.noDeviceConnected}}
        @nextButtonText={{t "shared_words.continue"}}
        @onClick={{action (optional @trackOnboardingStep) "connected-mobile-onboarding"}}
      />
    </wizard.slide>
    <wizard.slide as |slide|>
      <slide.body>
        <Shared::Wizards::DeviceSetup::StepTwo />
      </slide.body>
      <slide.footer
        @finishButtonText={{t "shared_words.next"}}
        @onClick={{action (optional @trackOnboardingStep) "completed-mobile-onboarding"}}
      />
    </wizard.slide>
  </Shared::Wizard>
  
  */
  {
    "id": "v1FCVf6s",
    "block": "[[[8,[39,0],null,[[\"@closable\",\"@onFinish\"],[false,[28,[37,1],[[30,0],[30,1]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"slide\"]],null,null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,2],null,[[\"@socialProfile\"],[[30,4]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,3,[\"footer\"]],null,[[\"@onCancel\",\"@isDisabled\",\"@nextButtonText\",\"@onClick\"],[[28,[37,1],[[30,0],[30,5]],null],[30,0,[\"noDeviceConnected\"]],[28,[37,3],[\"shared_words.continue\"],null],[28,[37,1],[[30,0],[28,[37,4],[[30,6]],null],\"connected-mobile-onboarding\"],null]]],null],[1,\"\\n  \"]],[3]]]]],[1,\"\\n  \"],[8,[30,2,[\"slide\"]],null,null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,7,[\"body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,5],null,null,null],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[8,[30,7,[\"footer\"]],null,[[\"@finishButtonText\",\"@onClick\"],[[28,[37,3],[\"shared_words.next\"],null],[28,[37,1],[[30,0],[28,[37,4],[[30,6]],null],\"completed-mobile-onboarding\"],null]]],null],[1,\"\\n  \"]],[7]]]]],[1,\"\\n\"]],[2]]]]],[1,\"\\n\"]],[\"@closeDeviceSetup\",\"wizard\",\"slide\",\"@socialProfile\",\"@cancelDeviceSetup\",\"@trackOnboardingStep\",\"slide\"],false,[\"shared/wizard\",\"action\",\"shared/wizards/device-setup/step-one\",\"t\",\"optional\",\"shared/wizards/device-setup/step-two\"]]",
    "moduleName": "shared/components/shared/wizards/device-setup.hbs",
    "isStrictMode": false
  });

  let DeviceSetupComponent = (_class = class DeviceSetupComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);
    }

    get noDeviceConnected() {
      return !this.auth.hasDevices;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = DeviceSetupComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, DeviceSetupComponent);
});